import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import {Box, TextField} from "@mui/material";
import Loading from "../../../../../ui/Loading";
import {CustomAxiosError} from "../../../../../../logics/api_config";
import {useToast} from "../../../../../../utils/contexts/toast-context";
import MuiAutocomplete from "../../../../../ui/mui/mui-input/MuiAutoComplete";
import {
    INewSpecialMonthDay
} from "../../../../../../utils/interfaces/my_documents/fiscal_registry/payment/INewSpecialMonthDay";
import useApiGetNewSpecialMonthDays from "./api-hooks/useApiGetNewSpecialMonthDays";
import useApiGetNewSpecialMonthDay from "./api-hooks/useApiGetNewSpecialMonthDay";


interface Props {
    obj: INewSpecialMonthDay | undefined,
    onChange: (obj: INewSpecialMonthDay | undefined) => void,
    className: string,
    label?: string,
    required?: boolean
}

const NewSpecialMonthDaySelect = ({
                                      obj: initialObj,
                                      label,
                                      onChange,
                                      required,
                                  }: Props) => {

    const {displayError} = useToast()
    const {t} = useTranslation()


    const [objs, setObjs] = useState<INewSpecialMonthDay[]>([]);
    const [obj, setObj] = useState<INewSpecialMonthDay | undefined>(initialObj)


    useEffect(() => {
        setObj(undefined);
        if (initialObj) {
            setObj(initialObj)
        }
    }, [initialObj]);


    const {
        data,
        isLoading,
        error,
    } = useApiGetNewSpecialMonthDays();
    if (error) {
        const axiosError = error as CustomAxiosError;
        displayError(axiosError.response.data.detail);
    }


    useEffect(() => {
        if (data) {
            setObjs(data)
        }
    }, [data]);


    const {
        data: detailedObj,
    } = useApiGetNewSpecialMonthDay(obj?.id);

    useEffect(() => {
        if (detailedObj) {
            setObj(detailedObj);
        }
    }, [detailedObj]);

    const handleOnChange = (event: React.SyntheticEvent, newValue: INewSpecialMonthDay | null) => {
        if (newValue) {
            onChange(newValue);
        } else {
            onChange(undefined);
        }
    };

    useEffect(() => {
        onChange(obj);
    }, [obj]);


    return (
        <>
            {isLoading ? (
                <Loading/>
            ) : (
                <>
                    <Box sx={{alignItems: 'center', width: '100%'}}>
                        <MuiAutocomplete
                            id="new_special_month_day-select"
                            options={objs}
                            getOptionLabel={(option) => option.day_of_the_month.toString()}
                            value={detailedObj ? detailedObj : null}
                            onChange={handleOnChange}
                            isOptionEqualToValue={(option, value) => option.id === value?.id && option.code === value?.code}
                            disableClearable={true}
                            renderInput={(params) => (
                                <TextField
                                    sx={{textTransform: 'capitalize'}}
                                    {...params}
                                    label={label ? t(label) : '' || t('new_special_month_day')}
                                    required={required}
                                />
                            )}
                        />
                    </Box>
                </>
            )}
        </>
    );
}

export default NewSpecialMonthDaySelect;